import React from 'react';
import PropTypes from 'prop-types';

import FilterNumberPair from 'components/search_sidebar/filter_number_pair';
import FilterSelect from 'components/search_sidebar/filter_select';
import FilterDatePickerPair from 'components/search_sidebar/filter_datepicker_pair';

import {
  filterLabelMappings,
  filterKeyMappings,
} from 'bundles/research/index/research_constants';
import { Col, Row } from 'react-bootstrap-5';

export default class LeaseFilterGroup extends React.Component {
  static propTypes = {
    compsView: PropTypes.bool,
    leaseFilter: PropTypes.object.isRequired,
    leaseSpaceTypeMappings: PropTypes.array.isRequired,
    leaseTypeMappings: PropTypes.array.isRequired,
    leaseUnits: PropTypes.array.isRequired,

    onFilterChange: PropTypes.func.isRequired,
  };

  render() {
    const {
      leaseFilter,
      leaseUnits,
      leaseSpaceTypeMappings,
      leaseTypeMappings,
      onFilterChange,
    } = this.props;

    return (
      <div className="d-flex flex-column gap-2">
        <Row>
          <Col>
            <FilterNumberPair
              filter={leaseFilter}
              label={filterLabelMappings['leasePrice']}
              valueKeys={filterKeyMappings['leasePrice']}
              onChange={onFilterChange}
            />
          </Col>
        </Row>
        <Row className="d-none d-md-flex">
          <Col>
            <FilterSelect
              label="Lease Rate Units"
              options={leaseUnits}
              value={leaseFilter.leaseRateUnits}
              onChange={e => onFilterChange(e, 'leaseRateUnits')}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FilterNumberPair
              filter={leaseFilter}
              label={filterLabelMappings['leaseSize']}
              valueKeys={filterKeyMappings['leaseSize']}
              onChange={onFilterChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FilterDatePickerPair
              filter={leaseFilter}
              label={filterLabelMappings['leaseExecutionDate']}
              valueKeys={filterKeyMappings['leaseExecutionDate']}
              onChange={onFilterChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FilterDatePickerPair
              filter={leaseFilter}
              label={filterLabelMappings['leaseDate']}
              valueKeys={filterKeyMappings['leaseDate']}
              onChange={onFilterChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FilterDatePickerPair
              filter={leaseFilter}
              label={filterLabelMappings['leaseExpirationDate']}
              valueKeys={filterKeyMappings['leaseExpirationDate']}
              onChange={onFilterChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FilterSelect
              label={filterLabelMappings['leaseType']}
              options={leaseTypeMappings}
              placeholder="Select a Lease Type"
              value={leaseFilter.leaseType}
              onChange={e => onFilterChange(e, 'leaseType')}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FilterSelect
              label={filterLabelMappings['leaseSpaceType']}
              options={leaseSpaceTypeMappings}
              placeholder="Select a Lease Space Type"
              value={leaseFilter.leaseSpaceType}
              onChange={e => onFilterChange(e, 'leaseSpaceType')}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
